"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentType = void 0;
/**
 * https://seismic.atlassian.net/wiki/spaces/UP/pages/3387626550/Types
 */
var ContentType;
(function (ContentType) {
    ContentType["Unknown"] = "Unknown";
    ContentType["File"] = "File";
    ContentType["Url"] = "Url";
    ContentType["DynamicallyRendered"] = "DynamicallyRendered";
    ContentType["MicroApp"] = "MicroApp";
    ContentType["ExternalVideo"] = "ExternalVideo";
    ContentType["Google"] = "Google";
    ContentType["Folder"] = "Folder";
})(ContentType || (exports.ContentType = ContentType = {}));
